import React, { FC, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { PageHeader, UserStateComponent } from '../../components';
import { CategoryItem, CreateCategory, ProductType } from '../../containers/housekeeping/products';
import { useTranslation } from '../../translations';
import { Fetcher, useFetcher, useToggle } from '../../utils';

export const DealerProducts: FC = () => {
  const { ts } = useTranslation();
  const [isCreatingCategory, toggleIsCreatingCategory] = useToggle(false);

  const fetcher = useFetcher(async () => {
    return await api.getProductCategories();
  });

  const history = useHistory();

  const categories = useMemo(() => {
    if (!fetcher.data) {
      return [];
    }

    return fetcher.data.filter((category) => category.isVendor);
  }, [fetcher]);

  if (!fetcher.success) {
    return <Fetcher result={fetcher} />;
  }

  return (
    <UserStateComponent>
      <PageHeader>{ts('vendor_product_categories')}</PageHeader>
      {isCreatingCategory && (
        <>
          <div>
            <Button color="secondary" onClick={toggleIsCreatingCategory} outline>
              {ts('back_to_categories')}
            </Button>
          </div>
          <hr />
          <div>
            <Row className="justify-content-center">
              <CreateCategory forcedType={ProductType.Vendor} />
            </Row>
          </div>
        </>
      )}
      {!isCreatingCategory && (
        <>
          <div>
            <Button color="primary" id="createCategory" onClick={toggleIsCreatingCategory}>
              {ts('create_new_category')}
            </Button>
          </div>
          <hr />
          <div>
            <Row className="justify-content-center">
              {categories.map((category) => (
                <Col
                  className="mb-10"
                  id={`category${category.id}`}
                  key={category.id}
                  lg={8}
                  xs={12}
                >
                  <CategoryItem
                    category={category}
                    onUpdate={fetcher.refresh}
                    redirectFn={(url) => {
                      history.push(`/housekeeping/dealers/products/${url}`);
                    }}
                  />
                </Col>
              ))}
            </Row>
          </div>
        </>
      )}
    </UserStateComponent>
  );
};
